// extracted by mini-css-extract-plugin
export default {"main":"ingredient-details_main__1eIpv"};